// @flow
import * as React from 'react';
import { EmptyCard, Button } from 'components';

type Props = {
  delay?: number,
  children: Function,
};

type State = {
  delay: number,
};

class RedirectNotice extends React.PureComponent<Props, State> {
  state: State;
  intervalID: ?number;

  constructor(props: Props) {
    super(props);
    this.state = {
      delay: props.delay ? props.delay : 10,
    };
  }

  countdown = () => {
    this.setState(({ delay }) => ({
      delay: delay - 1,
    }));
  };

  componentDidMount() {
    this.intervalID = window.setInterval(this.countdown, 1000);
  }

  componentWillUnmount() {
    this.intervalID && window.clearInterval(this.intervalID);
  }

  render() {
    return this.state.delay < 1 ? (
      this.props.children()
    ) : (
      <EmptyCard>
        <EmptyCard.Title>This Page has Moved.</EmptyCard.Title>
        <EmptyCard.Message>
          <p>
            You'll be automatically redirected in{' '}
            <strong>{this.state.delay}s</strong>. Make sure to update your
            bookmarks.
          </p>
          <Button.Primary onClick={() => this.setState({ delay: 0 })}>
            Go to New Location Now
          </Button.Primary>
        </EmptyCard.Message>
      </EmptyCard>
    );
  }
}

export default RedirectNotice;



// WEBPACK FOOTER //
// ./src/components/RedirectNotice.js